import React from 'react';
import { Select } from 'antd';

const NO_LANES = '__none';

/**
 * The board's two choices in the list's toolbar (KPR-1395): which element the
 * columns are (**Columns**), and which, if any, cuts them into swimlanes
 * (**Swimlanes**). Both offer only the elements the list can be drawn by
 * (`utils/board` boardElements); the swimlanes never offer the columns' own.
 *
 *   <BoardControls options={elements} by={name} lanes={name|null}
 *     onChange={({ by, lanes }) => …} isMobile />
 */
export default function BoardControls({ options = [], by = null, lanes = null, onChange, isMobile = false }) {
	if (!options.length) return null;
	const columnOptions = options.map(entry => ({ value: entry.name, label: entry.label }));
	const laneOptions = [
		{ value: NO_LANES, label: 'No swimlanes' },
		...options.filter(entry => entry.name !== by).map(entry => ({ value: entry.name, label: entry.label })),
	];
	return (
		<span className={`items-board-controls${isMobile ? ' items-board-controls--phone' : ''}`}>
			<label className="items-board-controls__field">
				<span className="items-board-controls__label">Columns</span>
				<Select
					className="items-board-controls__select"
					aria-label="Board columns"
					value={by}
					options={columnOptions}
					popupMatchSelectWidth={false}
					onChange={value => onChange?.({ by: value, lanes: lanes === value ? null : lanes })}
				/>
			</label>
			{laneOptions.length > 1 ? (
				<label className="items-board-controls__field">
					<span className="items-board-controls__label">Swimlanes</span>
					<Select
						className="items-board-controls__select"
						aria-label="Board swimlanes"
						value={lanes || NO_LANES}
						options={laneOptions}
						popupMatchSelectWidth={false}
						onChange={value => onChange?.({ by, lanes: value === NO_LANES ? null : value })}
					/>
				</label>
			) : null}
		</span>
	);
}
